import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateAuthToken } from 'state/app';

const Auth = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(updateAuthToken());
    }, 60_000);

    return () => clearInterval(intervalId);
  }, [dispatch]);

  return children;
};

export default Auth;
